import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Role } from '../enums/role';
import { isNil } from '@web/utils';
import { SelectItem } from '@web/shared/ui';
import { EntryNotFoundException } from '@web/common';

@Injectable({
  providedIn: 'root',
})
export class RoleProviderService {
  private readonly entries = new Map<Role, string>([
    [Role.Administrator, 'Administrator'],
    [Role.Subscriber, 'Subskrybent'],
    [Role.TechnicalAdmin, 'Administrator techniczny'],
    [Role.User, 'Użytkownik'],
    [Role.WarehouseEmployee, 'Pracownik magazynu'],
    [Role.WarehouseManager, 'Kierownik magazynu'],
  ]);

  public label(role: Role): Observable<string> {
    const result = this.entries.get(role);

    if (isNil(result)) {
      throw new EntryNotFoundException(`The label for "${role}" not found.`);
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<Role>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([role, label]) => new SelectItem(label, role),
      ),
    );
  }
}
